import React, { useState } from "react";

const CoreHeader = () => {
  return <></>
};

export default CoreHeader;
